import { SxProps, Theme } from '@mui/material';

interface TierBadgeColors {
  border: string;
  fill: string;
  gradient?: {
    highlight: string;
    mid: string;
    shadow: string;
  };
}

export const tierBadgeColors = {
  silver: {
    border: '#999798',
    fill: '#DAD9D7',
    gradient: {
      highlight: '#F6F5F3',
      mid: '#DAD9D7',
      shadow: '#B8B6B4',
    },
  },
  unavailable: {
    border: '#D6D5D5',
    fill: '#FFFFFF',
    gradient: undefined,
  },
  gold: {
    border: '#F1C947',
    fill: '#F7F2BA',
    gradient: {
      highlight: '#FFF8CF',
      mid: '#F7F2BA',
      shadow: '#E0B537',
    },
  },
} satisfies Record<string, TierBadgeColors>;

export type TierBadgeVariant = keyof typeof tierBadgeColors;

export const tierBadgeClassNames = {
  root: 'academy-tier-badge',
};

export const tierBadgeStyles = {
  root: (size: number) =>
    ({
      display: 'inline-flex',
      alignSelf: 'center',
      justifySelf: 'center',
      width: `${size}px`,
      height: `${size}px`,
      flex: '0 0 auto',
      '& svg': {
        display: 'block',
        width: '100%',
        height: '100%',
      },
    }) as SxProps<Theme>,
};
